import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-196b4d03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "right" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "right-info" }
const _hoisted_5 = { class: "right-show" }
const _hoisted_6 = { class: "right-show-count" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "count" }
const _hoisted_9 = { class: "right-show-count" }
const _hoisted_10 = { class: "info" }
const _hoisted_11 = { class: "count" }
const _hoisted_12 = {
  key: 1,
  class: "right-show-content"
}
const _hoisted_13 = { class: "amount" }
const _hoisted_14 = { class: "extra" }
const _hoisted_15 = {
  key: 2,
  class: "right-show-pic"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "right-date" }
const _hoisted_18 = {
  key: 0,
  class: "right-select"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divide" }, null, -1))
const _hoisted_20 = { class: "right-select-wrapper" }
const _hoisted_21 = { class: "right-get" }
const _hoisted_22 = { class: "right-agree" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divide" }, null, -1))
const _hoisted_26 = { class: "right-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RightSelect = _resolveComponent("RightSelect")!
  const _component_t_checkbox = _resolveComponent("t-checkbox")!
  const _component_t_button = _resolveComponent("t-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.detail.detailIcon,
        alt: "",
        class: "right-pic"
      }, null, 8, _hoisted_3),
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.detail.detailName), 1),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.detail.detailInfoType === 'count')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('总计可领取数量')), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.detail.detailInfoReceiveCount), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('累计已领取数量')), 1),
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.curReceiveCount), 1)
              ])
            ], 64))
          : (_ctx.detail.detailInfoType === 'text')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.detail.detailInfoText[0]), 1),
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.detail.detailInfoText[1]), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("img", {
                  src: _ctx.detail.detailInfoPic,
                  alt: ""
                }, null, 8, _hoisted_16)
              ]))
      ]),
      _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('该礼遇领取截止日：')) + _toDisplayString(_ctx.activityInfo.activityDate[1]), 1),
      (_ctx.detail.rightSize?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_RightSelect, {
                modelValue: _ctx.selectValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectValue) = $event)),
                options: _ctx.selectOptions,
                label: _ctx.$t('请选择')
              }, null, 8, ["modelValue", "options", "label"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_t_checkbox, {
            modelValue: _ctx.isAgree,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isAgree) = $event))
          }, null, 8, ["modelValue"]),
          (!_ctx.isSign)
            ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                _createTextVNode(_toDisplayString(_ctx.$t('我已阅读及同意')) + " ", 1),
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checkProto && _ctx.checkProto(...args)))
                }, _toDisplayString(_ctx.brand === 'tesla'
              ? _ctx.$t('富融银行Tesla车主专享礼遇条款及细则')
              : _ctx.$t('富融车主会·「赏」你所想优惠活动条款与细则')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.brand === 'tesla'
              ? _ctx.$t('；并已知悉本项礼遇的使用流程及细则')
              : _ctx.$t('；并已知悉本项礼遇的使用流程及细则方可领取「车生活」礼遇')), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.brand === 'tesla'
              ? _ctx.$t('点击“立即领取”即代表您已阅读并知悉该项礼遇的使用流程及细则')
              : _ctx.$t('点击“立即领取”即代表您已阅读并知悉该项「车生活」礼遇的使用流程及细则')), 1))
        ]),
        _createVNode(_component_t_button, {
          class: "right-btn",
          theme: "primary",
          text: _ctx.btnState.text,
          disabled: !_ctx.isAgree || _ctx.btnState.state === 'disabled',
          onClick: _ctx.handleClick
        }, null, 8, ["text", "disabled", "onClick"])
      ]),
      _hoisted_25,
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('使用流程及细则')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.detailTips, (item) => {
          return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item), 1))
        }), 128))
      ])
    ])
  ]))
}